export default __webpack_public_path__ + "static/media/solution.fe3abf02.png";